(function($) {
    $(function() {

        $('.tab-container .selector__cta').click(function(){
            $(this).parents('.selector').removeClass('is-active');
            $(this).parents('.selector').addClass('is-active');

            if($('.tab-container .selector').hasClass('is-active')) {
                $('.selector-container').addClass('is-inactive');
            } else {
                $('.selector-container').removeClass('is-inactive');
            }

        });

        $('.tab-container .selector .data-selector__item').click(function(){
            $('.tab-container .selector').removeClass('is-active');
            $('.selector-container').removeClass('is-inactive');

            $(this).parents('.selector').find('.selector__value').html($(this).html());
        });

        // CLICK SOMEWHERE ELSE
        $(document).mouseup(function(e) {
            var container = $('.tab-container .selector');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.tab-container .selector').removeClass('is-active');
                $('.selector-container').removeClass('is-inactive');
            }
        });

    });
})(jQuery);
